'use strict';

module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./src/util/cookies/browser_cookies.js
// module id = 17
// module chunks = 0